import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section aria-label="Testimonios" className="border-y border-line bg-dusk" data-id="element-253" data-mp="3fze2zvj28zum">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 lg:grid-cols-[1.3fr_1fr] lg:gap-14 lg:py-20" data-id="element-254" data-mp="3fxb22ggddmb4">
        <figure className="flex flex-col" data-id="element-255" data-mp="36yzeknasv4mw">
          <QuoteIcon className="h-10 w-10 text-pumpkin" aria-hidden="true" data-id="element-256" data-mp="3700up66oahbh" />
          <blockquote className="mt-5 font-display text-2xl font-medium leading-snug text-bone sm:text-3xl" data-id="element-257" data-mp="31zd1qeyvvqem">
            “{featured.quote}”
          </blockquote>
          <figcaption className="mt-6" data-id="element-258" data-mp="2x2mnlx6n34vu">
            <p className="font-bold text-bone" data-id="element-259" data-mp="2s2i5y3tzw441">{featured.name} <span className="font-normal text-mist" data-id="element-260" data-mp="2s3t9q3nfxbv5">· {featured.city}</span></p>
            <p className="text-sm text-mist" data-id="element-261" data-mp="v8wu4c4erodr">{featured.role}</p>
          </figcaption>
        </figure>

        <div className="flex flex-col divide-y divide-line" data-id="element-262" data-mp="qavddxugg15g">
          {rest.map(t => <figure key={t.name} className="py-6 first:pt-0 last:pb-0" data-id="element-263" data-mp="h4dcylqnjo46">
              <blockquote className="leading-relaxed text-bone/90" data-id="element-264" data-mp="m5b2xkhwlmg8">“{t.quote}”</blockquote>
              <figcaption className="mt-3 text-sm" data-id="element-265" data-mp="78aepqyx89mi">
                <span className="font-bold text-bone" data-id="element-266" data-mp="79v7bb1odihq">{t.name}</span>
                <span className="text-mist" data-id="element-267" data-mp="c7mwhxaxqqi8"> · {t.city} — {t.role}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}